import Buttons from "./Buttons.es6";

export default class {
    constructor(Component) {
        this.Component  = Component;
        this.Buttons    = new Buttons(Component);
        Component.Observer.register(this);
    }
    get container() { return this.Component.instance.querySelector('.popup-footer') }
    async render(page) { this.Buttons.render(page) }
    async update() {
        // Hide Footer when Empty
        this.container.classList.toggle('hidden', App.Utilities.String.empty(this.Buttons.container.innerHTML));
    }
}
